import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateFormularioPECATA = () => {
  const [loadingCreateFormularioPECATA, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateFormularioPECATA, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateFormularioPECATA, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateFormularioPECATA, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createFormularioPECATA = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudPecata(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createFormularioPECATA,
    loadingCreateFormularioPECATA,
    successCreateFormularioPECATA,
    errorCreateFormularioPECATA,
    dataCreateFormularioPECATA
  }

}

export default useCreateFormularioPECATA;
